import { useMutation } from "@tanstack/react-query";

import { queryClient } from "../../../config/react-query";
import { useToast } from "../../../hooks/useToast";
import { ramassageValidate } from "./actions";

export function useRamassageValidate() {
    const { successToast } = useToast();

    const mutation = useMutation({
        mutationFn: ramassageValidate,
        onSuccess: () => successToast("Le ramassage du dossier a bien été validé"),
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ["folders"],
            });
        },
    });

    return mutation;
}
